import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CommonStructured from "../common-components/CommonStructured";
import { useDispatch, useSelector } from "react-redux";
import { fetchGalleryData } from "../../redux/reducers/apiSlice";
import { selectAuth } from "../auth/auth.selector";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import FilterContainer from "../common-components/filters/filter-container";
import GymFilter from "../common-components/filters/gym-filter";
import StatusFilter from "../common-components/filters/status-filter";
import Modal from "react-modal";
import GalleryView from "./galleryView";
import GalleryForm from "./galleryForm";
import { isVideo } from "./galleryUtils";

const GalleryLanding = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { loading, galleryData } = useSelector((state) => state.api);

  const initialFilters = {
    // page: ,
    // limit: pageLimit,
    gym_id: "",
    status: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [modValues, setModValues] = useState({
    isModOpen: false,
    modName: "",
    rowData: null,
    image: "",
    gymName: "",
    cardType: "",
  });

  const getGalleryData = () => {
    const apiFilters = {
      ...filters,
      keyword: filters.gym_id?.value || "",
      status: filters.status?.value || "",
    };

    dispatch(
      fetchGalleryData({ token: userInfoData?.token, filters: apiFilters })
    );
  };

  useEffect(() => {
    getGalleryData();
  }, [userInfoData?.token, filters]);

  const groupGymsById = (gymPhotos) => {
    return gymPhotos.reduce((acc, curr) => {
      const gymId = curr.gym_id;
      if (!acc[gymId]) {
        acc[gymId] = [];
      }
      acc[gymId].push(curr);
      return acc;
    }, {});
  };

  const groupedGalleryData = groupGymsById(galleryData?.data || []);
  const groupedGalleryArray = Object.values(groupedGalleryData);

  const onCloseModal = () => {
    setModValues((prevs) => ({ ...prevs, isModOpen: false }));
  };

  const handleAdd = (type, data) => {
    if (type === "add")
      setModValues((prevs) => ({ ...prevs, isModOpen: true, cardType: type }));
    else if (type === "view")
      setModValues((prevs) => ({
        ...prevs,
        isModOpen: true,
        cardType: type,
        rowData: data,
      }));
  };

  return (
    <div>
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          contentLabel="Gallery"
          onRequestClose={() => onCloseModal()}
          ariaHideApp={false}
        >
          {modValues?.cardType === "add" ? (
            <GalleryForm
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              reloadGalleryData={getGalleryData}
            />
          ) : (
            <GalleryView
              onCloseModal={onCloseModal}
              modValues={modValues}
              userInfoData={userInfoData}
              reloadGalleryData={getGalleryData}
            />
          )}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Gallery"}
              createBtnTxt={"Add New"}
              onClickCreateBtn={() => handleAdd("add")}
              isReload={() => getGalleryData()}
            />
          </Col>
        </Row>

        <div>
          {/* <FilterContainer onReset={handleReset}> */}
          <FilterContainer>
            <GymFilter
              selectedGym={filters?.gym_id}
              setSelectedGym={(value) => {
                setFilters({ ...filters, gym_id: value });
              }}
            />

            <StatusFilter
              selectedStatus={filters?.status}
              setSelectedStatus={(option) => {
                setFilters({ ...filters, status: option });
              }}
            />
          </FilterContainer>
        </div>

        <br />

        <div
          className=""
          style={{
            width: "100%",
          }}
        >
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="grid__five">
              {groupedGalleryArray?.map((data, index) => (
                <div
                  className=""
                  style={{
                    backgroundColor: "#fff",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: "5px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                  key={data[0]?.uid}
                  onClick={() => {
                    handleAdd("view", data);
                  }}
                >
                  <div
                    style={{
                      height: "180px",
                    }}
                  >
                    {isVideo(data[0]?.image) ? (
                      <video
                        src={data[0]?.image}
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          height: "100%",
                        }}
                        controls
                      />
                    ) : (
                      <img
                        src={data[0]?.image}
                        alt=""
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          height: "100%",
                        }}
                      />
                    )}
                  </div>

                  <div
                    className="p-2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "500",
                      }}
                    >
                      {data[0]?.gym_id}
                    </p>
                    <div
                      style={{
                        fontSize: "16px",
                      }}
                    >
                      <div>{data[0]?.category_id}</div>
                      <div>
                        Status :{" "}
                        {data[0]?.status === "active" ? (
                          <span
                            style={{ color: "#0A701B", fontWeight: "bold" }}
                          >
                            Active
                          </span>
                        ) : (
                          <span style={{ color: "#DC3545" }}>Inactive</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default GalleryLanding;
